import { EXTENSION_IDENTIFIER } from "./serviceConstant";

export const dataCenterMap = {
  US: "https://www.zohoapis.com",
  AU: "https://www.zohoapis.com.au",
  EU: "https://www.zohoapis.eu",
  IN: "https://www.zohoapis.in",
  China: "https://www.zohoapis.com.cn",
  JP: "https://www.zohoapis.jp",
  SA: "https://www.zohoapis.sa",
  CA: "https://www.zohoapis.ca",
};

// https://www.zohoapis.com

export const accountUrlMap = {
  US: "https://accounts.zoho.com",
  AU: "https://accounts.zoho.com.au",
  EU: "https://accounts.zoho.eu",
  IN: "https://accounts.zoho.in",
  China: "https://accounts.zoho.com.cn",
  JP: "https://accounts.zoho.jp",
  SA: "https://accounts.zoho.sa",
  CA: "https://accounts.zohocloud.ca",
};

export const workdriveUrl = {
  US: "https://workdrive.zoho.com",
  AU: "https://workdrive.zoho.com.au",
  EU: "https://workdrive.zoho.eu",
  IN: "https://workdrive.zoho.in",
  China: "https://workdrive.zoho.com.cn",
  JP: "https://workdrive.zoho.jp",
  SA: "https://workdrive.zoho.sa",
  CA: "https://workdrive.zohocloud.ca",
};

export const WIDGET_NAME = "Easy Workdrive by Easy Pluginz";
export const WIDGET_URL = `https://widgets.v5.workdriveforcrm.easy-pluginz.com/relatedlist`;
export const WIDGET_DESCRIPTION =
  "The related list Widget allow you to use ZOHO WORKDRIVE functionality from ZOHO CRM";
export const RELATEDLIST_WIDGET_TYPE = "RELATED_LIST";
